(function() {
    var cache = {
        elements: {}
    };
    ProductSwatches(), ProductURL(), ProductQuantity(), ProductPrice(), VariantTitle(), VariantDescription(), VariantID(), VendorCatchProduct(), ProductBundleCards(), Accordions(), ProductRecommendations(), ProductOptions(), ProductAddToCartModal();

    function ProductSwatches() {
        const context = document.querySelector("[data-module-product-swatches]");
        if (!context) return;
        const elements = {
                swatches: document.querySelectorAll("[data-module-variant-swatch]")
            },
            classes = {
                selected: "state--selected",
                out_of_stock: "state--out-of-stock"
            };
        context.addEventListener("click", function(event) {
            event.preventDefault();
            let element = event.target.closest("[data-module-variant-swatch]");
            if (element.classList.contains(classes.selected)) return;
            let data = Theme.Helpers.get_element_data(element);
            document.dispatchEvent(new CustomEvent("productswatch:click", {
                detail: data
            })), set_as_selected(element)
        });

        function set_as_selected(selected_element) {
            elements.swatches.forEach(function(element) {
                element.classList.remove(classes.selected)
            }), selected_element.classList.add(classes.selected)
        }
    }

    function ProductQuantity() {
        var context = document.querySelector("[data-product-quantity]");
        if (!context) return;
        var elements = {
            input: context.querySelector("input"),
            buttons: context.querySelectorAll("span")
        };
        elements.buttons.forEach(Button);

        function Button(element) {
            element.addEventListener("click", function(event) {
                event.preventDefault(), event.stopPropagation();
                var current_quantity = parseInt(elements.input.value),
                    new_quantity = current_quantity + parseInt(element.dataset.value),
                    minimum = parseInt(elements.input.getAttribute("min"));
                new_quantity < minimum || (elements.input.setAttribute("value", new_quantity), document.dispatchEvent(new CustomEvent("productquantity:change", {
                    detail: {
                        quantity: new_quantity
                    }
                })))
            })
        }
    }

    function ProductPrice() {
        const element = document.querySelector("[data-module-product-price]");
        document.addEventListener("productoption:click", function(event) {
            element.textContent = event.detail.price
        })
    }

    function VariantTitle() {
        const element = document.querySelector("[data-module-variant-title]");
        element && document.addEventListener("productswatch:click", function(event) {
            element.innerText = event.detail.variant.custom_attributes.title
        })
    }

    function VariantDescription() {
        const element = document.querySelector("[data-module-variant-description]");
        element && document.addEventListener("productswatch:click", function(event) {
            element.innerText = event.detail.variant.custom_attributes.description, console.log(event.detail.variant.custom_attributes.description)
        })
    }

    function VariantID() {
        const element = document.querySelector("[data-module-variant-id]");
        document.addEventListener("productswatch:click", function(event) {
            update(event.detail.variant.id)
        }), document.addEventListener("productbundlecardswatch:click", function(event) {
            update(event.detail.bundle.variant.id)
        }), document.addEventListener("productoption:click", function(event) {
            update(event.detail.id)
        });

        function update(id) {
            element.setAttribute("value", id)
        }
    }

    function VendorCatchProduct() {
        var element = document.querySelector("[data-module-vendor-catch-product]");
        if (element) {
            var price = element.getAttribute("price"),
                price = parseInt(price);
            document.addEventListener("productquantity:change", function(event) {
                element.setAttribute("price", price * event.detail.quantity)
            })
        }
    }

    function ProductURL() {
        document.addEventListener("productswatch:click", function(event) {
            update(event.detail.variant.id)
        }), document.addEventListener("productbundlecardswatch:click", function(event) {
            update(event.detail.bundle.variant.id)
        });

        function update(variant_id) {
            let params = new URLSearchParams(window.location.search);
            params.set("variant", variant_id), window.history.replaceState({}, "", location.pathname + "?" + params.toString())
        }
    }

    function ProductBundleCards() {
        const contexts = document.querySelectorAll("[data-module-product-bundle-card]");
        if (contexts.length == 0) return;
        cache.elements.product_bundle_cards = contexts;
        const classes = {
            selected: "state--selected"
        };
        let all_variants = product;
        typeof extraBundleProduct < "u" && (all_variants = all_variants.concat(extraBundleProduct)), contexts.forEach(function(context) {
            const elements = {
                image: context.querySelector("[data-local-image]"),
                swatches_container: context.querySelector("[data-local-swatches]"),
                swatches: context.querySelectorAll("[data-local-swatch]"),
                variant_title: context.querySelector("[data-local-variant-title]"),
                variant_description: context.querySelector("[data-local-variant-description]")
            };
            elements.swatches_container.addEventListener("click", function(event) {
                event.preventDefault();
                const swatch = event.target.closest("[data-local-swatch]");
                if (!swatch || swatch.classList.contains(classes.selected)) return;
                const data = JSON.parse(swatch.querySelector("script").innerHTML),
                    variant_images = data.variant.variant_images;
                typeof variant_images < "u" && variant_images.forEach(function(el, index) {
                    var thumb = document.querySelector('.product__thumb-item[data-index="' + index + '"] img'),
                        image = document.querySelector('.product-main-slide[data-index="' + index + '"] img');
                    thumb.src = el.replace("_800x.", "_100x."), thumb.setAttribute("srcset", el.replace("_800x.", "_100x.")), image.src = el, image.setAttribute("srcset", el), image.setAttribute("data-photoswipe-src", el.replace("_800x.", "."))
                }), elements.image.src = data.variant.image, context.setAttribute("data-selected-variant", data.variant.title);
                const bundle_variant_id = get_bundle_variant_id();
                elements.variant_title.textContent = data.variant.custom_attributes.title, elements.variant_description.textContent = data.variant.custom_attributes.description, set_as_selected(elements.swatches, swatch), document.dispatchEvent(new CustomEvent("productbundlecardswatch:click", {
                    detail: {
                        variant: data.variant,
                        bundle: {
                            variant: {
                                id: bundle_variant_id
                            }
                        }
                    }
                }))
            })
        });

        function set_as_selected(elements, selected_element) {
            elements.forEach(e => e.classList.remove(classes.selected)), selected_element.classList.add(classes.selected)
        }

        function countInstances(string, word) {
            return string.split(word).length - 1
        }

        function get_bundle_variant_id() {
            let selected_variant = null,
                selected_variant_titles = [];
            contexts.forEach(function(element) {
                const variant_title = element.getAttribute("data-selected-variant").toLowerCase();
                selected_variant_titles.push(variant_title)
            });
            let sameVariantTitles = selected_variant_titles.every((val, i, arr) => val === arr[0]);
            return all_variants.forEach(function(variant) {
                let selected = !0;
                sameVariantTitles ? countInstances(variant.title.toLowerCase(), selected_variant_titles[0]) < selected_variant_titles.length && (selected = !1) : selected_variant_titles.forEach(function(selected_variant_title) {
                    variant.title.toLowerCase().includes(selected_variant_title) || (selected = !1)
                }), selected && (selected_variant = variant)
            }), document.querySelectorAll("[data-product-price]").forEach(function(price) {
                price.innerHTML = theme.Currency.formatMoney(selected_variant.price, theme.settings.moneyFormat), console.log(selected_variant)
            }), selected_variant.title == "No Blush - No Bronzer - No Highlighter" ? (document.getElementById("AddToCart").setAttribute("disabled", ""), document.querySelector("#AddToCart [data-add-to-cart-text]").innerText = "Customize your set") : (document.getElementById("AddToCart").removeAttribute("disabled"), document.querySelector("#AddToCart [data-add-to-cart-text]").innerText = "Add to cart"), selected_variant.id
        }
    }

    function Accordions() {
        document.querySelectorAll("[data-module-accordion]").forEach(function(context) {
            ({
                heading: context.querySelector("[data-local-heading]"),
                content: context.querySelector("[data-local-content]")
            }).heading.addEventListener("click", function(event) {
                event.preventDefault(), context.classList.toggle("state--active")
            })
        })
    }

    function ProductRecommendations() {
        const context = document.querySelector("[data-product-recommendations]");
        if (!context) return;
        const elements = {
            slider: context.querySelector("[data-local-slider]"),
            control_left: context.querySelector("[data-local-control-left]"),
            control_right: context.querySelector("[data-local-control-right]")
        }
    }

    function ProductOptions() {
        const context = document.querySelector("[data-module-product-options]");
        if (!context) return;
        const elements = context.querySelectorAll("[data-local-button]");
        elements.forEach(function(element) {
            const data = Theme.Helpers.get_element_data(element);
            element.addEventListener("click", function(event) {
                event.preventDefault(), document.dispatchEvent(new CustomEvent("productoption:click", {
                    detail: data
                })), elements.forEach(function(e) {
                    e.classList.remove("state--active"), e == element && e.classList.add("state--active")
                })
            })
        })
    }

    function ProductAddToCartModal() {
        var context = document.querySelector("[data-module-product-add-to-cart-modal]");
        if (console.log("product add to cart modal context", context), !context) return;
        ProductForm(), VariantId(), CloseButton(), ProductImage(), QuantityButtons(), QuantityInput(), Swatches(), Shades(), document.addEventListener("productcta:click", show), context.addEventListener("productform:submit", hide), context.addEventListener("closebutton:click", hide), context.addEventListener("click", function(event) {
            event.target == context && hide()
        });

        function ProductForm() {
            var element = context.querySelector("form");
            element.addEventListener("submit", function(event) {
                context.dispatchEvent(new CustomEvent("productform:submit"))
            })
        }

        function VariantId() {
            var element = context.querySelector("input[name='id']");
            context.addEventListener("swatch:click", function(event) {
                element.setAttribute("value", event.detail.variant_id)
            })
        }

        function CloseButton() {
            var element = context.querySelector("[data-local-close-button]");
            element.addEventListener("click", function(event) {
                context.dispatchEvent(new CustomEvent("closebutton:click"))
            })
        }

        function ProductImage() {
            var element = context.querySelector("[data-local-image]");
            context.addEventListener("swatch:click", function(event) {
                element.setAttribute("src", event.detail.variant_image_url)
            })
        }

        function QuantityInput() {
            var element = context.querySelector("input[name='quantity']");
            document.addEventListener("productform:quantity:change", function(event) {
                element.setAttribute("value", event.detail.quantity)
            }), context.addEventListener("quantitybutton:click", function(event) {
                var value = parseInt(element.getAttribute("value")),
                    new_value = value + event.detail.value;
                new_value < 1 || element.setAttribute("value", new_value)
            })
        }

        function QuantityButtons() {
            var elements = context.querySelectorAll("[data-local-quantity]");
            console.log("quantity buttons elements", elements), elements.forEach(function(element) {
                element.addEventListener("click", function(event) {
                    event.preventDefault(), event.stopPropagation();
                    var value = parseInt(element.dataset.value);
                    context.dispatchEvent(new CustomEvent("quantitybutton:click", {
                        detail: {
                            value
                        }
                    }))
                })
            })
        }

        function Swatches() {
            var elements = context.querySelectorAll("[data-local-swatch]");
            context.addEventListener("swatch:click", function() {
                elements.forEach(function(element) {
                    element.classList.remove("state--selected")
                })
            }), elements.forEach(function(element) {
                var data = theme.utils.get_element_json(element),
                    img = new Image;
                img.src = data.variant_image_url, element.addEventListener("click", function(event) {
                    event.preventDefault(), !element.classList.contains("state--selected") && (context.dispatchEvent(new CustomEvent("swatch:click", {
                        detail: data
                    })), element.classList.add("state--selected"))
                })
            })
        }

        function Shades() {
            var elements = context.querySelectorAll("[data-local-shade]");
            context.addEventListener("swatch:click", function(event) {
                elements.forEach(function(element) {
                    var data = theme.utils.get_element_json(element);
                    data.variant_id == event.detail.variant_id ? element.style.display = "block" : element.style.display = "none"
                })
            })
        }
    }
    let reviewStars = document.querySelector(".product-single__meta [data-oke-reviews-product-listing-rating]");
    if (reviewStars?.addEventListener("click", () => {
            document.querySelector(".okeReviews-widget-holder").scrollIntoView({
                behavior: "smooth"
            })
        }), document.querySelector("body").classList.contains("template-suffix-swiftbrow")) var productForm = document.querySelector(".product-block-variant-picker");
    else var productForm = document.querySelector(".qty-atc-wrap");
    var productFormAtc = document.querySelector(".product-single__form #AddToCart.add-to-cart"),
        productFormAtcQtyBreak = document.querySelector(".product-single__form .qty-breaks-atc"),
        productFormUpsellTrigger = document.querySelector(".product-single__form .product-upsell-trigger");
    if (productForm != null) {
        let handleIntersection2 = function(entries, observer) {
            entries.forEach(entry => {
                entry.isIntersecting ? (productFormAtc.classList.remove("sticky"), productFormAtcQtyBreak?.classList.remove("sticky"), productFormUpsellTrigger?.classList.remove("sticky"), document.querySelector("body").classList.contains("template-suffix-swiftbrow") && document.querySelector(".product-block-variant-picker .variant-wrapper").classList.remove("sticky")) : (productFormAtc.classList.add("sticky"), productFormAtcQtyBreak?.classList.add("sticky"), productFormUpsellTrigger?.classList.add("sticky"), document.querySelector("body").classList.contains("template-suffix-swiftbrow") && document.querySelector(".product-block-variant-picker .variant-wrapper").classList.add("sticky"))
            })
        };
        var handleIntersection = handleIntersection2;
        const stickyAtcOptions = {
            root: null,
            threshold: 0
        };
        var stickyAtcObserver = new IntersectionObserver(handleIntersection2, stickyAtcOptions);
        stickyAtcObserver.observe(productForm)
    }
})();
//# sourceMappingURL=/cdn/shop/t/481/assets/product.js.map?v=89511424666097197741749222949